import {useMutation} from "react-query";
import {useNavigate} from "react-router-dom";
import Alert from "react-s-alert";
import {HubAndSpokeService} from "../../../services/HubAndSpokeService";

export const useDeleteEventTrigger = () => {
  const navigate = useNavigate();

  return useMutation(
    async (eventTriggerId: string) => {
      const response = await HubAndSpokeService.deleteEventTrigger(
        eventTriggerId,
      );
      return response;
    },
    {
      onSuccess: () => {
        Alert.success("Event trigger successfully deleted!");
        navigate("/admin/hub-and-spoke/event-triggers");
      },
      onError: () => {
        Alert.error("Failed to delete event trigger");
      },
    },
  );
};
